/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import { useMutation, useLazyQuery, ServerError } from '@apollo/client'

import Alert from '../../../_metronic/partials/alert'
import { usePrevious } from '../../../_metronic/helpers/customHooks'
import 'react-circular-progressbar/dist/styles.css'
import query from '../../../setup/graphql/query'
import mutations from '../../../setup/graphql/mutations'
import { fetchStop } from '../../../redux/actions/common'
import {
  setKycApplication,
  setKycEligibility,
  setKycStep,
  setKycSubStep,
  setGuarantor,
  setDecisionMaker,
  setSingPassInfo,
  setDirector,
  setPartnerDetails,
} from './redux/actions'

import { Step1, Step3, Step3Sub1, Step4 } from './steps'
import ReactPixel from 'react-facebook-pixel'
import { AlexiRoutes } from '../../../utils/constants/AlexiRoutes.enum'
import axios from 'axios'
import { getIntegrationURLFromENV, handleSettingEnv } from '../../../utils/getIntegrationURLFromENV'
import { CheckCircleIcon } from '../../../svg/CheckCircleIcon'
import { Step3Icon } from '../../../svg/step3'
import { Step4Icon } from '../../../svg/step4'
import { Step5Icon } from '../../../svg/step5'
import { OverlayTrigger, Tooltip } from 'react-bootstrap-v5'

const KycApplication: FC = () => {
  const dispatch = useDispatch()
  const params: any = useParams()
  const history: any = useHistory()
  const { pathname } = useLocation()

  // let mainStep = 0, mainSubStep = 0;

  const { id } = params
  const searchQuery: any = parse(history.location.search)
  const partnerId = localStorage.getItem('partnerId')

  // if(searchQuery.length>0) {
  //   mainStep = Number(searchQuery.step.split('.')[0]);
  //   mainSubStep = Number(searchQuery.step.split('.')[1]);
  // }

  const prevStep: any = usePrevious(searchQuery)
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  //eslint-disable-next-line
  const [progress, setProgress] = useState<any>(0)

  const [getApplication, onSuccessGetApplication] = useLazyQuery(query.GET_APPLICATION)
  const [updateApplication, onSuccessUpdateApplicaton] = useMutation(mutations.UPDATE_APPLICATION)
  const loanApplication = useSelector((state: any) => state.kycApplication.loanApplication)
  const loanStep = useSelector((state: any) => state.kycApplication.loanStep)
  const loanSubStep = useSelector((state: any) => state.kycApplication.loanSubStep)
  const status = useSelector((state: any) => state.kycApplication.loanApplicationStatus)
  const singpassInfo = useSelector((state: any) => state.kycApplication.singpass)
  const entityPerson = useSelector((state: any) => state.kycApplication.entityPerson)
  const forwardWithButton = useSelector((state: any) => state.common.forwardWithButton)
  const companyVerificationMethod = useSelector(
    (state: any) => state.coApplicant.companyVerificationMethod
  )

  const pageRedirect = (loanApplication: any) => {
    if (history.location.search.length > 0) {
      const { applicationCompleteStep } = loanApplication
      const searchQuery: any = parse(history.location.search)
      const mainStep = Number(searchQuery?.step?.split('.')[0]) || applicationCompleteStep || 1
      const mainSubStep = Number(searchQuery?.step?.split('.')[1]) || applicationCompleteStep
      if (
        (applicationCompleteStep === null || !applicationCompleteStep) &&
        mainStep === 1 &&
        (mainSubStep === 3 || mainSubStep === null)
      ) {
        dispatch(setKycStep(1))
        dispatch(setKycSubStep(3))

        history.push(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=1.3`)
      }
      if (applicationCompleteStep === 5) {
        if (mainStep !== applicationCompleteStep) {
          dispatch(setKycStep(mainStep))
        } else {
          if (entityPerson.entity !== null || singpassInfo !== null) {
            dispatch(setKycStep(applicationCompleteStep))
          } else {
            dispatch(setKycStep(2))
            history.replace(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=2`)
          }
        }
      } else if (applicationCompleteStep === 4) {
        if (entityPerson.entity !== null || singpassInfo !== null) {
          dispatch(setKycStep(5))
          history.replace(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=5`)
        } else {
          dispatch(setKycStep(2))
          history.replace(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=2`)
        }
      } else if (applicationCompleteStep === 3) {
        if (mainStep !== applicationCompleteStep) {
          dispatch(setKycStep(mainStep))
        } else {
          if (entityPerson.entity !== null) {
            dispatch(setKycStep(applicationCompleteStep))
          } else {
            dispatch(setKycStep(1))
            dispatch(setKycSubStep(3))
            history.replace(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=1.3`)
          }
        }
      } else if (applicationCompleteStep === 2) {
        if (mainStep === applicationCompleteStep) {
          dispatch(setKycStep(2))
        } else {
          if (mainStep === 3 && companyVerificationMethod === 1 && entityPerson.entity == null) {
            history.push(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=2`)
          } else {
            dispatch(setKycStep(mainStep))
            dispatch(setKycSubStep(mainSubStep))
            history.push(
              `/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}?step=${mainStep}${
                mainSubStep > 0 ? `.${mainSubStep}` : ''
              }`
            )
          }
        }
      } else if (applicationCompleteStep < 2) {
        if (mainStep < applicationCompleteStep) {
          dispatch(setKycStep(mainStep))
          dispatch(setKycSubStep(mainSubStep))
        } else {
          dispatch(setKycStep(mainStep))
        }
      } else {
        dispatch(setKycStep(mainStep))
        dispatch(setKycSubStep(mainSubStep))
      }
    } else {
      dispatch(setKycStep(1))
      dispatch(setKycSubStep(2))
      history.replace(`/${AlexiRoutes.SG_ONBOARDING}/${loanApplication.id}`)
    }
  }

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }, [pathname, searchQuery])

  /**
   * Setting ENV & PartnerId
   */
  useEffect(() => {
    handleSettingEnv(searchQuery?.env)

    /**
     * Setting Partner Id
     */
    getPartnerDetails(searchQuery?.partner || partnerId)
  }, [])

  useEffect(() => {
    if (prevStep && Object.keys(prevStep).length > 0 && Object.keys(searchQuery).length > 0) {
      if (prevStep.step !== searchQuery.step && loanApplication && !forwardWithButton) {
        pageRedirect(loanApplication)
      }
    }

    if (Object.keys(searchQuery).length === 0 && id && status === 1) {
      dispatch(setKycStep(1))
      dispatch(setKycSubStep(2))
    }
  }, [searchQuery])

  useEffect(() => {
    const loanApplicationId = localStorage.getItem('loanApplicationId')

    if (id) {
      if (loanApplication === null && !searchQuery?.mobile && !searchQuery?.name) {
        getApplication({
          variables: {
            appId: id || loanApplicationId,
          },
        })
      }
    } else {
      const loanSubStep = status === 1 ? 1 : 0
      dispatch(setKycStep(1))
      dispatch(setKycSubStep(loanSubStep))
    }
  }, [id])

  useEffect(() => {
    if (loanStep > 0) {
      const progress = progressPercentageCalculate()
      setProgress(progress)
    }
  }, [loanStep, loanSubStep])

  useEffect(() => {
    if (onSuccessGetApplication.called && !onSuccessGetApplication.loading) {
      dispatch(fetchStop())
      if (onSuccessGetApplication.data) {
        const loanApplication = onSuccessGetApplication.data.getLatestApplication

        if (loanApplication !== null) {
          //eslint-disable-next-line
          const loanApplicationId = localStorage.getItem('loanApplicationId')
          const {
            //eslint-disable-next-line
            applicationCompleteStep,
            loanEligibility,
            shareholderKycStatus,
            externalDataStore,
          } = loanApplication
          const singpassInfo = externalDataStore.filter((o: any) => o.type === 'singpass')

          if (loanEligibility !== null) {
            dispatch(setKycEligibility(loanEligibility))
          }

          if (shareholderKycStatus.length > 0) {
            const decisionMaker = shareholderKycStatus.filter((o: any) => o.isDecisionMaker)[0]
            const gurantors = shareholderKycStatus.filter((o: any) => o.isGuarantor)
            const directors = shareholderKycStatus.filter((o: any) => o.isDirector)

            dispatch(setGuarantor(gurantors))
            dispatch(setDirector(directors))
            dispatch(setDecisionMaker(decisionMaker ? decisionMaker : null))
          }

          if (singpassInfo.length > 0) {
            dispatch(setSingPassInfo(singpassInfo[0].data))
          }

          pageRedirect(loanApplication)

          dispatch(setKycApplication(loanApplication))
        } else {
          if (status === 1) {
            history.replace(`/${AlexiRoutes.SG_ONBOARDING}/type`)
          }
        }
      } else {
      }

      if (onSuccessGetApplication.error) {
        setShowAlert(true)
        setAlertMsg('error')
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSuccessGetApplication.loading])

  useEffect(() => {
    if (onSuccessUpdateApplicaton.called && !onSuccessUpdateApplicaton.loading) {
      // dispatch(fetchStop());
      if (onSuccessUpdateApplicaton.data) {
        const { updateApplication } = onSuccessUpdateApplicaton.data
        const application = { ...loanApplication, ...updateApplication }
        dispatch(setKycApplication(application))
        onSuccessUpdateApplicaton.reset()
        dispatch(fetchStop())
      } else {
      }

      if (onSuccessUpdateApplicaton.error) {
        const { networkError } = onSuccessUpdateApplicaton.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessUpdateApplicaton.loading,
    onSuccessUpdateApplicaton.data,
    onSuccessUpdateApplicaton.error,
    onSuccessUpdateApplicaton.called,
  ])

  const getPartnerDetails = async (partnerId: string) => {
    const env = localStorage.getItem('env')
    const API_URL = getIntegrationURLFromENV(searchQuery?.env || env)
    if (env === 'prod') {
      partnerId =
        partnerId === undefined || partnerId === null
          ? (process.env.REACT_APP_ALEXI_DEFAULT_PARTNERID as string)
          : partnerId
    }
    const partnerData = await axios.get(`${API_URL}ext/api/businesspartner/${partnerId || ''}`)

    if (partnerData.data && partnerData.status === 200) {
      localStorage.setItem('partnerId', partnerData.data?.id)
      localStorage.setItem('partnerDetails', JSON.stringify(partnerData.data))
      dispatch(setPartnerDetails(partnerData.data))
    }
  }

  const additionalProps: any = {
    updateApplication: updateApplication,
    getApplication: getApplication,
  }

  const progressPercentageCalculate = () => {
    let progress = 0
    if (loanStep > 0 || loanSubStep > 0) {
      if (loanStep === 1) {
        progress = Math.floor(5 * (loanSubStep - 1))
      } else if (loanStep > 1) {
        progress = Math.floor(20 * loanStep)
      }
    }

    return progress
  }

  useEffect(() => {
    ReactPixel.track('Applicaiton Registration Start')
  }, [])

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 142) {
        document.body.classList.add('fixed')
      } else if (window.scrollY < 105) {
        document.body.classList.remove('fixed')
      }
    }

    window.addEventListener('scroll', handleScroll)

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className='container sgVendorApplication'>
      {(loanSubStep !== 0 || loanStep > 1) && (
        <div className={'cardNew stepperNewWrap'}>
          <ul className='stepperNew'>
            <li className={loanStep === 3 ? 'current' : loanStep > 3 ? 'completed' : ''}>
              <div className='stepBox'>
                <OverlayTrigger
                  key='CompanyInformationWrap'
                  placement='top'
                  overlay={
                    <Tooltip id={'steperTooltipCompanyInformation'}> Company Information</Tooltip>
                  }
                >
                  <div className='iconWrap'>
                    {loanStep > 3 ? (
                      <CheckCircleIcon fontSize={24} color='var(--text-color-success)' />
                    ) : (
                      <Step3Icon
                        color={
                          loanStep === 3 ? 'var(--text-color-primary)' : 'var(--border-color-grey1)'
                        }
                      />
                    )}
                  </div>
                </OverlayTrigger>

                <div className='right'>
                  <span>STEP 1</span>
                  <p className='truncate-text' data-tooltip='Company Information'>
                    Company Information
                  </p>
                </div>
              </div>
            </li>
            <li className={loanStep === 4 ? 'current' : loanStep > 4 ? 'completed' : ''}>
              <div className='stepBox'>
                <OverlayTrigger
                  key='ShareholdersWrap'
                  placement='top'
                  overlay={<Tooltip id={'steperTooltipShareholders'}> Shareholders</Tooltip>}
                >
                  <div className='iconWrap'>
                    {loanStep > 4 ? (
                      <CheckCircleIcon fontSize={24} color='var(--text-color-success)' />
                    ) : (
                      <Step4Icon
                        color={
                          loanStep === 4 ? 'var(--text-color-primary)' : 'var(--border-color-grey1)'
                        }
                      />
                    )}
                  </div>
                </OverlayTrigger>

                <div className='right'>
                  <span>STEP 2</span>
                  <p className='truncate-text' data-tooltip='Shareholders'>
                    Shareholders
                  </p>
                </div>
              </div>
            </li>
            <li className={loanStep === 5 ? 'current' : loanStep > 5 ? 'completed' : ''}>
              <div className='stepBox'>
                <OverlayTrigger
                  key='ReviewApplicationWrap'
                  placement='top'
                  overlay={
                    <Tooltip id={'steperTooltipReviewApplication'}> Review Application</Tooltip>
                  }
                >
                  <div className='iconWrap'>
                    {loanStep > 5 ? (
                      <CheckCircleIcon fontSize={24} color='var(--text-color-success)' />
                    ) : (
                      <Step5Icon
                        color={
                          loanStep === 5 ? 'var(--text-color-primary)' : 'var(--border-color-grey1)'
                        }
                      />
                    )}
                  </div>
                </OverlayTrigger>

                <div className='right'>
                  <span>STEP 3</span>
                  <p className='truncate-text' data-tooltip='Review Application'>
                    Review Application
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      )}

      <div className={loanStep === 1 ? 'current' : ''} data-kt-stepper-element='content'>
        {loanStep === 1 && <Step1 {...additionalProps} />}
      </div>

      <div className={loanStep === 2 ? 'current' : ''} data-kt-stepper-element='content'>
        {loanStep === 2 && <Step3 {...additionalProps} />}
      </div>

      <div className={loanStep === 3 ? 'current' : ''} data-kt-stepper-element='content'>
        {loanStep === 3 && <Step3 {...additionalProps} />}
      </div>

      <div className={loanStep === 4 ? 'current' : ''} data-kt-stepper-element='content'>
        {loanStep === 4 && <Step3Sub1 {...additionalProps} />}
      </div>

      <div className={loanStep === 5 ? 'current' : ''} data-kt-stepper-element='content'>
        {loanStep === 5 && <Step4 {...additionalProps} />}
      </div>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}
    </div>
  )
}

export default KycApplication
